<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <br>
                <br>
                <br>
                <br>
                <div class="text-center">
                    <h1 class="h3 mb-4">
                        <b>
                            <span class="icon icon-glyphicons-basic-settings align-middle mr-1"></span>
                            <span class="align-middle">An upgrade is in progress</span>
                        </b>
                    </h1>
                    <p class="mb-4">
                        This feature will be available again soon - please check back again later.
                    </p>
                    <p class="text-secondary small">
                        Need to get in touch? Contact us at
                        <a href="mailto:support@affinitylearning.ca">
                            support@affinitylearning.ca</a
                        >.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MaintenanceView",
}
</script>